import React, { FC } from 'react'

interface CategoryTypeItemProps  {
    categoryTypename: string;
}

const CategoryTypeItem: FC<CategoryTypeItemProps> = ({categoryTypename}) => {
  return (
    <div  className={`tw-ml-5 tw-mt-3 tw-text-base tw-font-semibold tw-text-slategray`}>{categoryTypename ?? "-"}</div>
  )
}

export default CategoryTypeItem